<div class="table-wrapper bg-white" *blockUI="'invoice-list'">
  <div class="mb-2 d-flex justify-content-end">
    <button class="btn viewBtn spear-button-background text-white btn-sm" (click)="openPopup(addNewProspectiveClient,'lg')">
      Add Prospective Client
    </button>
  </div>
  <table class="table spear-table-header-background search-spear-background">
    <caption>
      NPI
    </caption>
    <thead>
      <tr>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Full Name
          <app-table-column-sort
            [columnName]="'last_name'"
            [orderBy]="'id'"
            [orderDirection]="'asc'"
          ></app-table-column-sort>
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Company Name
          <app-table-column-sort
            [columnName]="'last_name'"
            [orderBy]="'id'"
            [orderDirection]="'asc'"
          ></app-table-column-sort>
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Title
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Email
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Work Phone
        </th>
        <th
          class="border-0 cursor-pointer"
          scope="col"
        >
          Mobile Phone
        </th>
      </tr>
    </thead>

    <tbody *ngIf="invoices?.length; else showNoInvoice">
      <ng-container *ngFor="let invoice of invoices">
        <tr class="bg-white">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </ng-container>
    </tbody>
    <ng-template #showNoInvoice>
      <tbody>
        <tr class="bg-white">
          <td colspan="6" class="text-center">Data not available</td>
        </tr>
      </tbody>
    </ng-template>
  </table>
</div>
<div class="invoice-pagination">
  <div
    class="px-0 py-0 spearPaginationWrapper paginationWrapper d-flex"
    *ngIf="invoices?.length"
  >
    <ngb-pagination
      [(collectionSize)]="invoiceTotal"
      [(page)]="invoicePage"
      [pageSize]="invoiceLimit"
      [maxSize]="10"
      [boundaryLinks]="true"
      (pageChange)="onPageChangeinvoices($event)"
    >
    </ngb-pagination>

    <div class="selected d-flex align-items-center">
      <select
        (change)="onSizeChangeinvoices($event.target.value)"
        class="custom-select table-select h-100"
        [(ngModel)]="invoiceLimit"
      >
        <option [value]="30">30</option>
        <option [value]="50">50</option>
        <option [value]="75">75</option>
        <option [value]="100">100</option>
      </select>

      <p class="mb-0 ml-2 text-nowrap">
        Showing {{ invoicePage * invoiceLimit - invoiceLimit + 1 }} -
        {{
          invoicePage * invoiceLimit > invoiceTotal
            ? invoiceTotal
            : invoicePage * invoiceLimit
        }}
        of {{ invoiceTotal }}
      </p>
    </div>
  </div>
</div>

<ng-template #addNewProspectiveClient let-modal>
  <div class="modal-header">
    <h6>New Prospective Client</h6>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalService.dismissAll()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-form text-sm">
    <form>
      <div class="row mb-2">
        <div class="col-6">
          <div class="position-relative">
            <span class="text-dark fw-500 required" for="company"
              >Company</span
            >
            <input
              id="company"
              type="text"
              class="form-control"
              [ngbTypeahead]="searchCompany"
              [resultTemplate]="rtSearchCompany"
              [inputFormatter]="searchCompanyFormatter"
              (blur)="searchCompanyLoader = false"
            />
            <div *ngIf="searchCompanyLoader" class="preloader"></div>
            <ng-template #rtSearchCompany let-r="result" let-t="term">
              <div
                [term]="t"
                (click)="selectedCompany(r)"
              >
                {{ r.provider_name_business }}
              </div>
            </ng-template>
          </div>
        </div>

        <div class="col-6">
          <div>
            <span class="text-dark fw-500 required" for="title"
              >Title</span
            >
            <input
              type="text"
              name="title"
              id="title"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500 required" for="first_name"
              >First Name</span
            >
            <input
              type="text"
              name="first_name"
              id="first_name"
              class="form-control"
            />
          </div>
        </div>

        <div class="col-6">
          <div>
            <span class="text-dark fw-500 required" for="last_name"
              >Last Name</span
            >
            <input
              type="text"
              name="last_name"
              id="last_name"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="email"
              >Email</span
            >
            <input
              type="text"
              name="email"
              id="email"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="work_phone"
              >Work Phone</span
            >
            <input
              type="text"
              name="work_phone"
              id="work_phone"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <div>
            <span class="text-dark fw-500" for="mobile_phone"
              >Mobile Phone</span
            >
            <input
              type="text"
              name="mobile_phone"
              id="mobile_phone"
              class="form-control"
            />
          </div>
        </div>

      </div>

      <div class="mt-4 d-flex justify-content-end">
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-sm text-white mr-1"
            (click)="modalService.dismissAll()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn limos-button-background btn-sm text-white mr-1"
            (click)="saveClientContact()"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
